// extracted by mini-css-extract-plugin
module.exports = {"outer":"_1KMvo","edit":"_2sUyo","heading":"veMwZ","amount":"_3JFEC","cardOuter":"_5u9vZ","bottomTextWrap":"IhDlm","bottomText":"_2aFb_"};